/**
 * Definición de rutas como módulo JS puro (sin imports de Vue/componentes).
 * Importable tanto desde el router (Vite) como desde scripts Node (sitemap).
 */

// Idiomas soportados
export const SUPPORTED_LOCALES = ["es", "en"];
export const DEFAULT_LOCALE = "es";

/**
 * Definición de rutas con URLs localizadas y metadatos de sitemap.
 * El campo `component` NO está aquí: se asocia en el router vía componentMap.
 */
export const routeDefinitions = [
  {
    name: "home",
    paths: { es: "", en: "" },
    meta: { titleKey: "seo.titles.home" },
    sitemap: { priority: 1.0, changefreq: "daily", hasImage: true },
  },
  {
    name: "test",
    paths: { es: "test-velocidad", en: "speed-test" },
    meta: { titleKey: "seo.titles.test" },
    sitemap: { priority: 0.9, changefreq: "daily", hasImage: true },
  },
  {
    name: "mapa",
    paths: { es: "mapa-cobertura", en: "coverage-map" },
    meta: { titleKey: "seo.titles.mapa" },
    sitemap: { priority: 0.8, changefreq: "daily" },
  },
  {
    name: "datos",
    paths: { es: "datos-abiertos", en: "open-data" },
    meta: { titleKey: "seo.titles.testAbiertos" },
    sitemap: { priority: 0.9, changefreq: "daily" },
  },
  {
    name: "datosAbiertosDetail",
    paths: { es: "datos-abiertos/:idHistorial", en: "open-data/:idHistorial" },
    meta: { titleKey: "seo.titles.testAbiertosDetail", excludeFromSitemap: true },
  },
  {
    name: "historial",
    paths: { es: "historial", en: "history" },
    meta: { titleKey: "seo.titles.historial" },
    sitemap: { priority: 0.7, changefreq: "weekly" },
  },
  {
    name: "historialDetail",
    paths: { es: "historial/:idHistorial", en: "history/:idHistorial" },
    meta: { titleKey: "seo.titles.historialDetail", excludeFromSitemap: true },
  },
  {
    name: "estadisticas",
    paths: { es: "estadisticas", en: "statistics" },
    meta: { titleKey: "seo.titles.estadisticas" },
    sitemap: { priority: 0.7, changefreq: "weekly" },
  },
  {
    name: "estadisticasUbicacion",
    paths: { es: "estadisticas/:ubicacion", en: "statistics/:ubicacion" },
    meta: { titleKey: "seo.titles.ciudad", excludeFromSitemap: true },
  },
  {
    name: "estadisticasUbicacionCP",
    paths: { es: "estadisticas/:ubicacion/:codigoPostal", en: "statistics/:ubicacion/:codigoPostal" },
    meta: { titleKey: "seo.titles.ciudad", excludeFromSitemap: true },
  },
  {
    name: "cnmcData",
    paths: { es: "cnmc-data", en: "cnmc-data" },
    meta: { titleKey: "seo.titles.cnmcData" },
    sitemap: { priority: 0.7, changefreq: "weekly" },
  },
  {
    name: "servicios",
    paths: { es: "servicios", en: "services" },
    meta: { titleKey: "seo.titles.servicios" },
    sitemap: { priority: 0.6, changefreq: "monthly" },
  },
  {
    name: "faq",
    paths: { es: "preguntas-frecuentes", en: "faq" },
    meta: { titleKey: "seo.titles.faq" },
    sitemap: { priority: 0.7, changefreq: "monthly" },
  },
  {
    name: "apps",
    paths: { es: "aplicaciones-moviles", en: "mobile-apps" },
    meta: { titleKey: "seo.titles.aplicacionesMoviles" },
    sitemap: { priority: 0.6, changefreq: "monthly" },
  },
  {
    name: "configuracion",
    paths: { es: "configuracion", en: "settings" },
    meta: { titleKey: "seo.titles.configuracion" },
    sitemap: { priority: 0.4, changefreq: "monthly" },
  },
  {
    name: "politicaPrivacidad",
    paths: { es: "informacion-legal", en: "legal-information" },
    meta: { titleKey: "seo.titles.politicaPrivacidad" },
    sitemap: { priority: 0.4, changefreq: "yearly" },
  },
  {
    name: "accesibilidad",
    paths: { es: "accesibilidad", en: "accessibility" },
    meta: { titleKey: "seo.titles.accesibilidad" },
    sitemap: { priority: 0.4, changefreq: "yearly" },
  },
  {
    name: "mapaSitio",
    paths: { es: "mapa-sitio", en: "sitemap" },
    meta: { titleKey: "seo.titles.mapaSitio" },
    sitemap: { priority: 0.5, changefreq: "monthly" },
  },
  {
    name: "iframe",
    paths: { es: "widget", en: "widget" },
    meta: { titleKey: "seo.titles.iframe" },
    sitemap: { priority: 0.5, changefreq: "monthly" },
  },
  {
    name: "opiniones",
    paths: { es: "opiniones", en: "reviews" },
    meta: { titleKey: "seo.titles.opiniones" },
    sitemap: { priority: 0.6, changefreq: "daily" },
  },
  {
    name: "medios",
    paths: { es: "medios", en: "media" },
    meta: { titleKey: "seo.titles.medios" },
    sitemap: { priority: 0.5, changefreq: "monthly" },
  },
  {
    name: "derechos",
    paths: { es: "derechos-y-reclamaciones", en: "rights-and-complaints" },
    // isHidden: el middleware del router redirige a "/" si entra en pro.
    // Mantenemos la URL viva en pre/local para revisar antes de la
    // validacion juridica + coordinacion con la Oficina del Ministerio.
    meta: { titleKey: "seo.titles.derechos", isHidden: true, excludeFromSitemap: true },
  },
  {
    name: "politicaCookies",
    paths: { es: "politica-cookies", en: "cookie-policy" },
    meta: { titleKey: "seo.titles.politicaCookies" },
    sitemap: { priority: 0.4, changefreq: "yearly" },
  },
  {
    name: "testEmbed",
    paths: { es: "test-embed", en: "test-embed" },
    meta: { titleKey: "seo.titles.test", excludeFromSitemap: true },
  },
];
